import { SourceType } from "@tandemdiabetes/sugarmate-api-react-client"
import {
  Navigate,
  useParams,
} from "@tanstack/react-router"
import { DataConsentContent } from "./DataConsentContent"

import { PageTemplate } from "src/components"
import { usePolyglot } from "src/contexts"

function isSourceTypeValid(value: string): value is SourceType {
  return Object.values(SourceType).includes(value as SourceType)
}

export function DataConsent() {
  const polyglot = usePolyglot()
  const sourceType = useParams({
    from: "/private/account/data_source/data_consent/$sourceType",
    select: (s) => s.sourceType,
  })

  if (!isSourceTypeValid(sourceType)) {
    return (
      <Navigate
        to={"/account/data_source"}
        params={{}}
        search={{}}
        replace
      />
    )
  }

  return (
    <PageTemplate
      user="account"
      title={polyglot.t("components.page_header.pages.update_your_account")}
      backRoutePath="/account/data_source"
    >
      <DataConsentContent sourceType={sourceType} />
    </PageTemplate>
  )
}
